import { formatDateToBR } from "../../../../../utils/time";
import { SETableColumnsProps } from "../../../../components/SETable";
import { Grid, IconButton } from "@mui/material";
import {
  RiCheckboxCircleFill,
  RiCloseCircleFill,
  RiDeleteBin6Line,
  RiErrorWarningFill,
  RiFileCopy2Fill,
  RiPencilLine,
} from "react-icons/ri";
import React from "react";
import SETableIconButton from "../../../../components/SETable/SETableIconButton";
import { formatCPF } from "../../../../../utils/utils";

interface TableColumnsProps {
  handleEdit?: (data?: any) => void;
  handleCopy?: (data?: any) => void;
  handleUpdateStatus?: (data?: any) => void;
  handleDelete?: (id?: number | string) => void;
}

export const tableColumns = ({
  handleEdit = () => {},
  handleCopy = () => {},
  handleDelete = () => {},
  handleUpdateStatus = () => {},
}: TableColumnsProps): SETableColumnsProps[] => [
  {
    id: "dataCriacao",
    label: "Data",
    width: 50,
    customField: formatDateToBR,
    align: "left",
  },
  {
    id: "uf",
    label: "UF",
    customField: (uf: any) => uf?.sigla,
    align: "left",
  },
  {
    id: "tipo",
    label: "Perfil",
    align: "left",
  },
  {
    id: "cpf",
    label: "CPF",
    align: "left",
    customField: (cpf: any) => formatCPF(cpf),
  },
  {
    id: "nome",
    label: "Nome",
    align: "left",
  },
  {
    id: "descricaoUnidadeOrganizacional",
    label: "Unid. Org.",
    align: "left",
  },
  {
    id: "ufs",
    label: "Empresa Habilitada",
    align: "left",
    customField: (ufs: any) =>
      // @ts-ignore
      [...new Set(ufs?.flatMap((uf) => uf?.empresaVinculada))].join(", "),
  },
  {
    id: "treinamento",
    label: "Testador",
    align: "left",
    minWidth: 150,
    customField: (treinamento: any) => (treinamento ? "Sim" : "Não"),
  },
  {
    id: "status",
    label: "Status",
    align: "center",
    width: 320,
    customField: (value: any, row: any) => (
      <Grid container justifyContent="center" alignItems="center">
        <Grid item md={6} container alignItems="center" justifyContent="center">
          <IconButton onClick={() => handleUpdateStatus(row)}>
            <>
              {value === "APROVADO" && (
                <RiCheckboxCircleFill
                  size={26}
                  color="#66BD91"
                  title={"Aprovado"}
                />
              )}
              {(value === "PENDENTE" || value === null) && (
                <RiErrorWarningFill
                  size={26}
                  color="#F6E566"
                  title={"Pendente"}
                />
              )}
              {value === "REPROVADO" && (
                <RiCloseCircleFill
                  size={26}
                  color="#FF0000"
                  title={"Reprovado"}
                />
              )}
            </>
          </IconButton>
          <SETableIconButton onClick={() => handleEdit(row)}>
            <RiPencilLine size={20} color="#555770" />
          </SETableIconButton>
          <SETableIconButton onClick={() => handleCopy(row)}>
            <RiFileCopy2Fill size={20} color="#555770" />
          </SETableIconButton>
          <SETableIconButton onClick={() => handleDelete(row.id)}>
            <RiDeleteBin6Line size={20} color="#555770" />
          </SETableIconButton>
        </Grid>
      </Grid>
    ),
  },
];
